import { render } from "./SelectDifficulty.vue?vue&type=template&id=a86c95cc&scoped=true"
import script from "./SelectDifficulty.vue?vue&type=script&lang=js"
export * from "./SelectDifficulty.vue?vue&type=script&lang=js"

import "@/assets/css/essayWriting.sass?vue&type=style&index=0&id=a86c95cc&lang=sass&scoped=true"

import exportComponent from "/Users/priscillacancar/Documents/Coding/1) Engram-site/Engram/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a86c95cc"]])

export default __exports__